<template>
    <div class="main-room-wrapper">
        <h4 class="room-name">{{ roomTitle }}</h4>
        <div class="cover-img-wrapper">
            <img :src="mainImage"
                 class="cover-img" alt="Imagen del cuarto">
        </div>
        <vue-picture-swipe :items="images" class="img-thumbnails"></vue-picture-swipe>
        <div class="commodities-wrapper">
            <div class="room-commodity">
                <img src="../assets/images/icons/baseline-person-24px.svg"
                     alt="Capacity">
                <span>{{ capactiy }}</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/baseline-wifi-24px.svg" alt="Wi-Fi">
                <span class="commodity-name">Wi-Fi</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/baseline-free_breakfast-24px.svg"
                     alt="Desayuno">
                <span class="commodity-name">{{ breakfastCount }} Desayuno</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/snowflake.svg"
                     alt="Aire Acondicionado">
                <span class="commodity-name">A/C</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/hanger.svg"
                     alt="Closet">
                <span class="commodity-name">Closet</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/shower.svg"
                     alt="Baño Privado">
                <span class="commodity-name">Baño Privado</span>
            </div>
            <div class="room-commodity">
                <img src="../assets/images/icons/old-typical-phone.svg"
                     alt="Teléfono">
                <span class="commodity-name">Teléfono</span>
            </div>
        </div>
    </div>
</template>

<script>
    import VuePictureSwipe from 'vue-picture-swipe';

    export default {
        name: "RoomView",
        components: {VuePictureSwipe},
        props: {
            roomTitle: {
                type: String,
                required: true
            },
            capactiy: {
                type: Number,
                required: true
            },
            breakfastCount: {
                type: Number,
                required: true
            },
            images: {
                type: Array,
                required: true
            },
            mainImage: {
                type: String,
                required: true
            }
        },
        data() {
            return {
            }
        }
    }
</script>

<style scoped>
    .main-room-wrapper {
        display: flex;
        max-width: 480px;
        overflow: hidden;
        flex-direction: column;
        padding: 15px 0;
        margin-bottom: 50px;
        opacity: 0.8;
        border: 1px solid #b8b8b8;
    }

    .main-room-wrapper:hover {
        opacity: 1;
        box-shadow: 0 3px 5px 0 #b8b8b8;
    }

    .cover-img-wrapper {
        position: relative;
    }

    .cover-img {
        width: 100%;
    }

    .room-name {
        text-align: center;
        margin: 10px 0;
        font-size: 1.8rem;
    }

    .img-thumbnails {
        margin-top: 5px;
        display: flex;
        justify-content: center;
    }

    .commodities-wrapper {
        display: flex;
        margin-top: 15px;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .room-commodity {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 10px 10px;
    }

    .room-commodity img {
        width: 2rem;
    }

    .room-commodity:hover {
        opacity: 1;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .main-room-wrapper {
            opacity: 1;
        }
    }
</style>